import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sub-header-text',
  templateUrl: './sub-header-text.component.html',
  styleUrls: ['./sub-header-text.component.scss'],
})
export class SubHeaderTextComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() boldText: string;
  @Input() showDeleteButton = false;
  @Output() deleteButtonEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() showSortButton = false;
  @Output() sortButtonEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() renamable = false;
  @Output() renameButtonEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() showReloadButton = false;
  @Output() reloadButtonEvent: EventEmitter<any> = new EventEmitter<any>();
}
